import React from 'react';
import { findDOMNode } from 'react-dom';
import { TimelineLite, TweenMax } from 'gsap';
import ScrollMagic from 'scrollmagic';

export default {

    initialise(NavMobile) {
        this.NavMobileNode = findDOMNode(NavMobile);
        let controller = new ScrollMagic.Controller();

        new ScrollMagic.Scene({
            triggerHook: 'onEnter',
            duration: 200
        })
            .setTween(TweenMax.to(this.NavMobileNode.querySelector('.bg-slidedown-animated'), 0.5, {height: '75px'}))
            .addTo(controller);
    },

    handleHamburgerClick(event, NavMobile) {
        this.toggleHamburger(event.currentTarget, NavMobile);
    },

    handlePageChange(NavMobile) {
        this.toggleHamburger(NavMobile.hamburgerRef, NavMobile)
    },

    toggleHamburger(el, NavMobile) {
        this.NavMobileNode = findDOMNode(NavMobile);
        this.bgMask = this.NavMobileNode.getElementsByClassName('bg-mask');
        this.navInner = this.NavMobileNode.getElementsByClassName('nav-inner');
        this.navItems = [...this.NavMobileNode.querySelectorAll('.main-nav > li')];

        el.classList.toggle('do-open');
        el.style.pointerEvents = 'none';

        if (el.classList.contains('do-open')) {
            this.animateIn(el);
        } else {
            this.animateOut(el);
        }
    },

    animateIn(el) {
        let tl = new TimelineLite();

        this.NavMobileNode.classList.add('open');
        tl.set('body', {css: {position: 'fixed'}})
            .set(this.NavMobileNode, {'height': '100vh'})
            .to(this.bgMask, 0.5, {width: '100%', ease: Power4.easeOut})
            .set(this.navInner, {css: {display: 'block'}})
            .staggerFromTo(this.navItems, 0.25, {x: -50, opacity: 0}, {x: 0, opacity: 1}, 0.1)
            .add(function() {
                el.style.pointerEvents = 'auto';
            });
    },

    animateOut(el) {
        let tl = new TimelineLite();

        this.NavMobileNode.classList.remove('open');
        tl.set(this.navInner, {css: {display: 'none'}})
            .set(this.NavMobileNode, {'height': '72px'})
            .set(this.bgMask, {width: '0px', ease: Power4.easeOut})
            .set('body', {css: {position: 'relative'}})
            .add(function() {
                el.style.pointerEvents = 'auto';
            });
    },

    animateSubNavIn(event, title, identifier) {
        event.preventDefault();
        let tl = new TimelineLite(),
            NavMobile = findDOMNode(this),
            subMenu = NavMobile.getElementsByClassName(identifier)[0],
            mainMenu = NavMobile.getElementsByClassName('main-nav')[0],
            subTitle = NavMobile.getElementsByClassName('subnav-heading')[0];

        tl.to(mainMenu, 0.25, {x: -window.outerWidth})
            .add(function(){
                subTitle.innerHTML = title;
                subTitle.dataset.identifier = identifier;
                subTitle.style.display = 'block';
            })
            .fromTo(subTitle, '0.2', {x: 0, y: 150, opacity: 0}, {y: 0, opacity: 1})
            .add(function(){
                mainMenu.style.display = 'none';
                subMenu.style.display = 'block';
            })
            .staggerFromTo(subMenu.children, 0.25, {x: -50, opacity: 0}, {x: 0, opacity: 1}, 0.1);
    },

    animateSubNavOut(event) {
        let el = event.currentTarget,
            tl = new TimelineLite(),
            NavMobile = findDOMNode(this),
            subMenu = NavMobile.getElementsByClassName(el.dataset.identifier)[0],
            mainMenu = NavMobile.getElementsByClassName('main-nav')[0],
            subTitle = NavMobile.getElementsByClassName('subnav-heading')[0];

        tl.to(subTitle, '0.2', {x: 50, opacity: 0})
            .add(function(){
                subTitle.innerHTML = '';
                subTitle.dataset.identifier = '';
                subTitle.style.display = 'none';
                subTitle.style.opacity = 1;
            })
            .staggerTo(subMenu.children, 0.25, {x: 50, opacity: 0}, 0.1, 0)
            .add(function(){
                mainMenu.style.display = 'block';
                subMenu.style.display = 'none';
                subMenu.style.opacity = 1;
                subMenu.style.translateX = 0;
            })
            .fromTo('.mobile-nav .main-nav', 0.25, {x: -window.outerWidth}, {x: 0})
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/layout/NavMobile/animations.js